const AuthorizationNameSpace = 'authorization';

const AuthorizationActionTypes = Object.freeze({
    Login: 'Login',
    AdminLogin: 'AdminLogin',
    Logout: 'Logout',
    RecoverPassword: 'RecoverPassword',
    PingAuth: 'PingAuth',
    PingAccess: 'PingAccess',
});

const AuthorizationMutationTypes = Object.freeze({});

const AuthorizationGetterTypes = Object.freeze({
    GetGroup: 'GetGroup',
    GetId: 'GetId',
    GetRole: 'GetRole',
});

export {
    AuthorizationNameSpace,
    AuthorizationActionTypes,
    AuthorizationMutationTypes,
    AuthorizationGetterTypes,
};